/**
 * WOW · feel / parents / measure (prefixes fx.* par.* msr.*): Juno's reaction lines, sound & feel
 * settings, the grown-ups corner (weekly report, timelapse, family sharing) and the dev funnel dashboard.
 */
export const en = {
  // Juno reactions (rotating variants)
  'fx.j.stepDone.1': 'Nice lines!',
  'fx.j.stepDone.2': 'Great step!',
  'fx.j.stepDone.3': 'Looking good!',
  'fx.j.stepDone.4': 'Step {n} done. Wonderful!',
  'fx.j.greatCapture.1': 'Wow, look at that drawing!',
  'fx.j.greatCapture.2': 'Beautiful work, {name}!',
  'fx.j.greatCapture.3': "That one belongs in a frame!",
  'fx.j.retry.1': "Good try! Let's draw it once more.",
  'fx.j.retry.2': 'Every artist practises. You can do it!',
  'fx.j.retry.3': "Almost there. You've got this!",
  'fx.j.lessonDone.1': "You finished the whole lesson, {name}! I'm so proud.",
  'fx.j.lessonDone.2': 'Another drawing for your journal. Bravo!',
  'fx.j.lessonDone.3': "What a lesson! You're getting better every day.",
  'fx.j.firstDrawing.1': 'Your very first drawing! This is a big day, {name}!',
  'fx.j.firstDrawing.2': 'Look what you made! Your art adventure starts now.',
  'fx.j.comeback.1': 'Welcome back, {name}! I missed your drawings.',
  'fx.j.comeback.2': 'Hello again, {name}! Ready to draw something new?',
  'fx.j.comeback.3': "You're back! Your pencils were waiting for you.",
  'fx.j.hello.1': "Hi {name}! Let's draw together.",
  'fx.j.hello.2': 'Hello, {name}! What shall we draw today?',
  // Sound & feel settings
  'fx.set.musicVolume': 'Music volume',
  'fx.set.worldMusic': 'Every world plays its own calm tune. Lessons stay quiet so you can hear the teacher.',
  'fx.set.sfxVolume': 'Sound effects volume',
  'fx.set.voiceVolume': 'Voice volume',
  'fx.set.haptics': 'Vibration',
  // Grown-ups corner
  'par.entry': 'Grown-ups corner',
  'par.title': 'Grown-ups corner',
  'par.off': 'The grown-ups corner is turned off right now.',
  'par.whichChild': 'Which child?',
  'par.noProfile': 'Create a profile first.',
  'par.tab.report': 'Weekly report',
  'par.tab.timelapse': 'Timelapse',
  'par.tab.family': 'Send to family',
  'par.error': 'Something went wrong. Please try again.',
  'par.saved': 'Saved to your device.',
  'par.share': 'Share',
  'par.save': 'Save',
  'par.gate.title': 'For grown-ups',
  'par.gate.body': 'Reports, videos and sharing live here. Please ask a grown-up to answer.',
  'par.gate.q': 'What is {a} × {b}?',
  'par.gate.wrong': 'Not quite. Here is another one.',
  'par.gate.back': 'Go back',
  'par.rep.kicker': 'Weekly report',
  'par.rep.title': "{name}'s week",
  'par.rep.thisWeek': 'This week',
  'par.rep.lastWeek': 'Last week',
  'par.rep.tipQuiet': 'A quiet week. A 10-minute drawing date together works wonders.',
  'par.rep.tipGood': 'Lovely rhythm! Ask {name} to tell you the story behind a drawing.',
  'par.rep.tipGreat': '{name} drew a lot this week. Hang a favourite on the fridge!',
  'par.rep.drawings': 'Drawings',
  'par.rep.vsLast': '{n} last week',
  'par.rep.minutes': 'Minutes',
  'par.rep.days': 'Days active',
  'par.rep.lessons': 'Lessons',
  'par.rep.skills': 'Skills that grew',
  'par.rep.noSkills': 'Skills grow with every lesson. Start one together this week!',
  'par.rep.noSkillsShort': 'Ready for a first lesson',
  'par.rep.levelUp': 'Level {n}!',
  'par.rep.xp': '+{n} XP',
  'par.rep.level': 'Level {n}',
  'par.rep.chart': 'Minutes each day',
  'par.rep.minN': '{n} min',
  'par.rep.drawN': '{n} drawings',
  'par.rep.worlds': 'Colouring the worlds',
  'par.rep.share': 'Make a share card',
  'par.rep.private': 'Made on this device. Nothing is sent until you share it.',
  'par.rep.cardReady': 'Your card is ready',
  'par.rep.cardBody': 'Send it to family or keep it as a little keepsake of the week.',
  'par.rep.top': 'Star skill of the week',
  'par.rep.footer': 'Drawn on paper · shared with Sketchling',
  'par.tl.title': 'Drawing journey timelapse',
  'par.tl.body': "Turn {name}'s journal into a short video with music, made right here on the device.",
  'par.tl.empty': 'Photos of drawings show up here once {name} saves a few to the journal.',
  'par.tl.count': '{n} drawings · about {s} s',
  'par.tl.cardTitle': "{name}'s drawing journey",
  'par.tl.cardSub': '{n} drawings since {date}',
  'par.tl.end': 'Keep drawing!',
  'par.tl.endSub': '{n} drawings by {name}',
  'par.tl.unsupported': 'This browser cannot record video. You can still watch the preview; the app and recent Chrome or Safari can save it.',
  'par.tl.making': 'Making the video… {p}%',
  'par.tl.ready': 'Your video is ready!',
  'par.tl.again': 'Make it again',
  'par.tl.make': 'Make the video',
  'par.tl.preview': 'Play the preview',
  'par.fam.title': 'Send to grandparents',
  'par.fam.empty': 'Once {name} saves drawings with photos, you can send them from here.',
  'par.fam.pick': '{n}/{max} picked',
  'par.fam.body': 'Pick up to 5 drawings. We make private links that open in any browser, where family can leave a kind word for {name}. Their notes appear in the journal.',
  'par.fam.who': 'Who is it for?',
  'par.fam.to.grand': 'Grandparents',
  'par.fam.to.family': 'Family',
  'par.fam.to.friends': 'Friends',
  'par.fam.hello.grand': 'Dear Grandma and Grandpa,',
  'par.fam.hello.family': 'Hello family,',
  'par.fam.hello.friends': 'Hi friends,',
  'par.fam.msg': 'Look what {name} drew! Tap a link to see the drawing and leave a little note:',
  'par.fam.sign': 'With love, {name}',
  'par.fam.msgTitle': 'Drawings from {name}',
  'par.fam.copied': 'Message copied. Paste it into your family chat.',
  'par.fam.copy': 'Copy message',
  'par.fam.how': 'We will open your phone’s share sheet with a ready-made message.',
  'par.fam.sending': 'Creating links…',
  'par.fam.send': 'Create links & send',
  'par.fam.offline': 'Links need the internet. Connect and try again.',
  // Funnel dashboard (dev)
  'msr.open': 'Funnel & retention dashboard',
  'msr.title': 'Funnel & retention',
  'msr.days': '{n} d',
  'msr.buffer': 'This device: {n} events waiting',
  'msr.lastSent': 'last sent {at}',
  'msr.consentOff': 'Analytics consent is off: events never leave this device.',
  'msr.refresh': 'Refresh',
  'msr.flush': 'Send now',
  'msr.sent': '{n} events sent',
  'msr.error': 'Could not load the dashboard (is the API running?).',
  'msr.installs': 'Installs',
  'msr.events': 'Events',
  'msr.d1': 'D1 return',
  'msr.d7': 'D7 return',
  'msr.eligible': 'of {n} installs',
  'msr.funnel': 'Core funnel (installs)',
  'msr.ofStart': 'of start',
  'msr.ofPrev': 'of previous step',
  'msr.daily': 'Daily active installs',
  'msr.onboarding': 'Onboarding steps reached',
  'msr.noData': 'No events yet.',
  'msr.perf': 'Performance (p50 / p75 / p95)',
  'msr.perf.startup': 'App start → ready (ms)',
  'msr.perf.lesson': 'Lesson open (ms)',
  'msr.perf.longTasks': 'Long tasks / min',
  'msr.perf.fps': 'Frames per second',
  'msr.perf.heap': 'JS memory (MB)',
  'msr.perf.dom': 'Elements on screen',
  'msr.perf.low': 'Battery saver share',
  'msr.perf.n': '{n} samples',
  'msr.step.app_open': 'Opened the app',
  'msr.step.onboarding_complete': 'Finished onboarding',
  'msr.step.lesson_start': 'Started a lesson',
  'msr.step.capture': 'Photographed a drawing',
  'msr.step.first_drawing_done': 'First drawing done',
  'msr.step.creature_alive': 'Creature came alive',
  'msr.step.return_d1': 'Came back on day 1',
  'msr.step.return_d7': 'Came back on day 7',
  'msr.step.paywall_view': 'Saw the plans',
  'msr.step.paywall_convert': 'Started a plan',
};

export const vi: Record<keyof typeof en, string> = {
  'fx.j.stepDone.1': 'Nét đẹp lắm!',
  'fx.j.stepDone.2': 'Bước này tuyệt quá!',
  'fx.j.stepDone.3': 'Trông xinh lắm!',
  'fx.j.stepDone.4': 'Xong bước {n} rồi. Giỏi quá!',
  'fx.j.greatCapture.1': 'Oa, bức tranh đẹp quá!',
  'fx.j.greatCapture.2': '{name} vẽ đẹp lắm!',
  'fx.j.greatCapture.3': 'Tranh này phải đóng khung treo lên mới được!',
  'fx.j.retry.1': 'Con cố gắng lắm! Mình vẽ lại một lần nữa nhé.',
  'fx.j.retry.2': 'Hoạ sĩ nào cũng phải luyện tập. Con làm được mà!',
  'fx.j.retry.3': 'Gần được rồi. Cố lên con!',
  'fx.j.lessonDone.1': '{name} học xong cả bài rồi! Cô tự hào lắm.',
  'fx.j.lessonDone.2': 'Thêm một bức tranh cho cuốn sổ của con. Hoan hô!',
  'fx.j.lessonDone.3': 'Bài học tuyệt vời! Mỗi ngày con lại vẽ đẹp hơn.',
  'fx.j.firstDrawing.1': 'Bức tranh đầu tiên của con! Hôm nay là ngày đặc biệt đó, {name}!',
  'fx.j.firstDrawing.2': 'Nhìn con vẽ được gì này! Hành trình hoạ sĩ bắt đầu từ đây.',
  'fx.j.comeback.1': 'Chào mừng {name} quay lại! Cô nhớ tranh của con lắm.',
  'fx.j.comeback.2': 'Chào {name}! Hôm nay mình vẽ gì mới nhé?',
  'fx.j.comeback.3': 'Con về rồi! Bút chì đang chờ con đó.',
  'fx.j.hello.1': 'Chào {name}! Mình cùng vẽ nhé.',
  'fx.j.hello.2': 'Xin chào {name}! Hôm nay mình vẽ gì đây?',
  'fx.set.musicVolume': 'Âm lượng nhạc',
  'fx.set.worldMusic': 'Mỗi thế giới có một giai điệu nhẹ nhàng riêng. Trong bài học nhạc tạm tắt để con nghe rõ lời cô.',
  'fx.set.sfxVolume': 'Âm lượng hiệu ứng',
  'fx.set.voiceVolume': 'Âm lượng giọng đọc',
  'fx.set.haptics': 'Rung',
  'par.entry': 'Góc phụ huynh',
  'par.title': 'Góc phụ huynh',
  'par.off': 'Góc phụ huynh đang tạm tắt.',
  'par.whichChild': 'Bé nào?',
  'par.noProfile': 'Hãy tạo hồ sơ cho bé trước.',
  'par.tab.report': 'Báo cáo tuần',
  'par.tab.timelapse': 'Video hành trình',
  'par.tab.family': 'Gửi gia đình',
  'par.error': 'Có lỗi xảy ra. Vui lòng thử lại.',
  'par.saved': 'Đã lưu vào thiết bị.',
  'par.share': 'Chia sẻ',
  'par.save': 'Lưu',
  'par.gate.title': 'Dành cho người lớn',
  'par.gate.body': 'Báo cáo, video và chia sẻ nằm ở đây. Nhờ bố mẹ trả lời giúp nhé.',
  'par.gate.q': '{a} × {b} bằng bao nhiêu?',
  'par.gate.wrong': 'Chưa đúng rồi. Thử câu khác nhé.',
  'par.gate.back': 'Quay lại',
  'par.rep.kicker': 'Báo cáo tuần',
  'par.rep.title': 'Tuần của {name}',
  'par.rep.thisWeek': 'Tuần này',
  'par.rep.lastWeek': 'Tuần trước',
  'par.rep.tipQuiet': 'Một tuần yên ả. Thử một buổi cùng vẽ 10 phút với bé nhé.',
  'par.rep.tipGood': 'Nhịp vẽ rất đều! Hãy hỏi {name} kể câu chuyện đằng sau một bức tranh.',
  'par.rep.tipGreat': 'Tuần này {name} vẽ rất nhiều. Dán một bức yêu thích lên tủ lạnh nào!',
  'par.rep.drawings': 'Bức tranh',
  'par.rep.vsLast': 'tuần trước {n}',
  'par.rep.minutes': 'Phút',
  'par.rep.days': 'Ngày có vẽ',
  'par.rep.lessons': 'Bài học',
  'par.rep.skills': 'Kỹ năng tiến bộ',
  'par.rep.noSkills': 'Kỹ năng lớn lên sau mỗi bài học. Tuần này cùng bé học một bài nhé!',
  'par.rep.noSkillsShort': 'Sẵn sàng cho bài học đầu tiên',
  'par.rep.levelUp': 'Lên cấp {n}!',
  'par.rep.xp': '+{n} XP',
  'par.rep.level': 'Cấp {n}',
  'par.rep.chart': 'Số phút mỗi ngày',
  'par.rep.minN': '{n} phút',
  'par.rep.drawN': '{n} bức tranh',
  'par.rep.worlds': 'Tô màu các thế giới',
  'par.rep.share': 'Tạo thẻ chia sẻ',
  'par.rep.private': 'Được tạo ngay trên máy. Không gửi đi đâu cho tới khi bạn chia sẻ.',
  'par.rep.cardReady': 'Thẻ đã sẵn sàng',
  'par.rep.cardBody': 'Gửi cho gia đình hoặc giữ làm kỷ niệm nhỏ của tuần.',
  'par.rep.top': 'Kỹ năng nổi bật của tuần',
  'par.rep.footer': 'Vẽ trên giấy · chia sẻ cùng Sketchling',
  'par.tl.title': 'Video hành trình vẽ',
  'par.tl.body': 'Biến cuốn sổ tranh của {name} thành một video ngắn có nhạc, tạo ngay trên máy.',
  'par.tl.empty': 'Ảnh tranh sẽ hiện ở đây khi {name} lưu vài bức vào sổ tranh.',
  'par.tl.count': '{n} bức tranh · khoảng {s} giây',
  'par.tl.cardTitle': 'Hành trình vẽ của {name}',
  'par.tl.cardSub': '{n} bức tranh từ {date}',
  'par.tl.end': 'Vẽ tiếp nào!',
  'par.tl.endSub': '{n} bức tranh của {name}',
  'par.tl.unsupported': 'Trình duyệt này không quay được video. Bạn vẫn xem thử được; ứng dụng hoặc Chrome, Safari bản mới có thể lưu video.',
  'par.tl.making': 'Đang tạo video… {p}%',
  'par.tl.ready': 'Video đã xong!',
  'par.tl.again': 'Tạo lại',
  'par.tl.make': 'Tạo video',
  'par.tl.preview': 'Xem thử',
  'par.fam.title': 'Gửi ông bà',
  'par.fam.empty': 'Khi {name} lưu tranh có ảnh, bạn có thể gửi chúng từ đây.',
  'par.fam.pick': 'Đã chọn {n}/{max}',
  'par.fam.body': 'Chọn tối đa 5 bức tranh. Chúng tôi tạo đường link riêng mở được trên mọi trình duyệt, để gia đình gửi lời khen cho {name}. Lời khen sẽ hiện trong sổ tranh.',
  'par.fam.who': 'Gửi cho ai?',
  'par.fam.to.grand': 'Ông bà',
  'par.fam.to.family': 'Gia đình',
  'par.fam.to.friends': 'Bạn bè',
  'par.fam.hello.grand': 'Ông bà kính yêu,',
  'par.fam.hello.family': 'Cả nhà ơi,',
  'par.fam.hello.friends': 'Các bạn ơi,',
  'par.fam.msg': 'Xem {name} vẽ gì này! Bấm vào link để xem tranh và gửi một lời nhắn nhỏ nhé:',
  'par.fam.sign': 'Thương, {name}',
  'par.fam.msgTitle': 'Tranh của {name}',
  'par.fam.copied': 'Đã sao chép lời nhắn. Dán vào nhóm chat gia đình nhé.',
  'par.fam.copy': 'Sao chép lời nhắn',
  'par.fam.how': 'Chúng tôi sẽ mở bảng chia sẻ của điện thoại với lời nhắn soạn sẵn.',
  'par.fam.sending': 'Đang tạo link…',
  'par.fam.send': 'Tạo link và gửi',
  'par.fam.offline': 'Cần có mạng để tạo link. Hãy kết nối rồi thử lại.',
  'msr.open': 'Bảng phễu & tỉ lệ quay lại',
  'msr.title': 'Phễu & tỉ lệ quay lại',
  'msr.days': '{n} ngày',
  'msr.buffer': 'Máy này: {n} sự kiện đang chờ gửi',
  'msr.lastSent': 'gửi lần cuối {at}',
  'msr.consentOff': 'Chưa đồng ý chia sẻ số liệu: sự kiện không rời khỏi máy.',
  'msr.refresh': 'Làm mới',
  'msr.flush': 'Gửi ngay',
  'msr.sent': 'Đã gửi {n} sự kiện',
  'msr.error': 'Không tải được bảng số liệu (API có đang chạy không?).',
  'msr.installs': 'Lượt cài',
  'msr.events': 'Sự kiện',
  'msr.d1': 'Quay lại ngày 1',
  'msr.d7': 'Quay lại ngày 7',
  'msr.eligible': 'trên {n} lượt cài',
  'msr.funnel': 'Phễu chính (lượt cài)',
  'msr.ofStart': 'so với đầu phễu',
  'msr.ofPrev': 'so với bước trước',
  'msr.daily': 'Lượt cài hoạt động mỗi ngày',
  'msr.onboarding': 'Các bước hướng dẫn đã tới',
  'msr.noData': 'Chưa có sự kiện nào.',
  'msr.perf': 'Hiệu năng (p50 / p75 / p95)',
  'msr.perf.startup': 'Mở app → sẵn sàng (ms)',
  'msr.perf.lesson': 'Mở bài học (ms)',
  'msr.perf.longTasks': 'Tác vụ dài / phút',
  'msr.perf.fps': 'Khung hình / giây',
  'msr.perf.heap': 'Bộ nhớ JS (MB)',
  'msr.perf.dom': 'Phần tử trên màn hình',
  'msr.perf.low': 'Tỉ lệ tiết kiệm pin',
  'msr.perf.n': '{n} mẫu',
  'msr.step.app_open': 'Mở ứng dụng',
  'msr.step.onboarding_complete': 'Xong hướng dẫn',
  'msr.step.lesson_start': 'Bắt đầu bài học',
  'msr.step.capture': 'Chụp ảnh tranh',
  'msr.step.first_drawing_done': 'Xong bức tranh đầu',
  'msr.step.creature_alive': 'Sinh vật sống dậy',
  'msr.step.return_d1': 'Quay lại ngày 1',
  'msr.step.return_d7': 'Quay lại ngày 7',
  'msr.step.paywall_view': 'Xem các gói',
  'msr.step.paywall_convert': 'Đăng ký gói',
};
